import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type GetSwiftlaneUserGroupsRequest = {
  buildingId: number
}

export type SwiftlaneUserGroup = {
  id: string
  name: string
}

export const getSwiftlaneUserGroupsQueryKey = (data: GetSwiftlaneUserGroupsRequest) => [
  'useGetSwiftlaneUserGroups',
  data,
]

const getSwiftlaneUserGroups = async (data: GetSwiftlaneUserGroupsRequest) => {
  const response = await authAPI.get<SwiftlaneUserGroup[]>(
    `/swiftlane/user-group/${data.buildingId}`,
  )
  return response.data
}

export const useGetSwiftlaneUserGroups = (data: GetSwiftlaneUserGroupsRequest, enabled = true) =>
  useQuery({
    enabled: enabled && Boolean(data.buildingId),
    queryFn: () => getSwiftlaneUserGroups(data),
    queryKey: getSwiftlaneUserGroupsQueryKey(data),
  })
